<div class="modal fade show" id="cycle-count-add-modal" tabindex="-1" aria-labelledby="cycle-count-add-modalLabel"
    aria-hidden="true" [ngClass]="{'expanded': isExpanded}" [ngStyle]="{'display': 'block'}">
    <div class="modal-dialog modal-xl">
        @if (showLoader()) {
            <app-loader></app-loader>
        }
        <div class="modal-content">
            <app-popup-header
                [isExpanded]="isExpanded"
                [title]="'Warehouses'"
                [hideCreationDate]="true"
                (onClose)="close()"
                (onExpandCollapse)="isExpanded = $event"
            ></app-popup-header>
            <div class="modal-body cycle-count-popup-body">
                <inavista-grid #cycleCountAddPopupGrid
                    [config]="gridConfig"
                    (rowsSelected)="onRowsSelected($event)"
                    (exportRequested)="onExportRequested()" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
                <span [title]="selectedRows().length ? '' : 'Select at least one warehouse to create its cycle count.'">
                    <button type="button" class="btn btn-sm btn-success me-1" [disabled]="!selectedRows().length"
                        (click)="onCreate()">Create{{ selectedRows().length ? ' (' + selectedRows().length + ')' : '' }}</button>
                </span>
            </div>
        </div>
    </div>
</div>
